import React, { useState, useEffect } from "react";
import axios from "../api/axios";
import { RiEyeLine } from "react-icons/ri";
import { API_URL } from "../config";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext"; // Para obtener el usuario
import { getRoute } from "../utils/routes"; // Tu función para rutas dinámicas

function SubirPDF() {
  const [pdfData, setPdfData] = useState([]);
  const navigate = useNavigate();
  const { user } = useAuth();

  const moverArchivo = async (fileName, to) => {
    try {
      const confirmar = window.confirm(
        `¿Seguro que quieres mover el archivo a ${to}?`
      );
      if (!confirmar) return;

      await axios.post("/api/move", {
        fileName,
        from: "/cancelados", // carpeta actual
        to,
      });

      alert(`Archivo movido a ${to}`);
      fetchFiles();
    } catch (error) {
      console.error(
        "Error moviendo archivo:",
        error.response?.data || error.message
      );
    }
  };

  const fetchFiles = async () => {
    try {
      const res = await axios.get("/api/listPDFcan");
      setPdfData(res.data);
    } catch (error) {
      console.error("Error cargando archivos:", error);
    }
  };

  useEffect(() => {
    fetchFiles();
  }, []);

  const goTo = (path) => {
    if (!user) {
      alert("Debes iniciar sesión");
      navigate("/login");
      return;
    }
    navigate(getRoute(user, path)); // Usa la función para generar la ruta según el rol
  };

  return (
    <div className="w-full p-6 min-h-[calc(100vh-6rem)]">
      <h1 className="text-3xl font-bold mb-4">Presupuestos Cancelados</h1>

      <div className="flex justify-between items-center w-full">
        {/* Botones a la izquierda */}
        <div className="flex space-x-4">
          <button
            onClick={() => goTo("presupuesto")}
            className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition"
          >
            Presupuestos
          </button>
          <button
            onClick={() => goTo("aprobados")}
            className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition"
          >
            Aprobados
          </button>
        </div>
      </div>

      <table className="table-fixed w-full border border-secondary-900 mt-4">
        <thead className="bg-secondary-900">
          <tr>
            <th className="w-2/4 border border-secondary-900 px-4 py-2">
              Archivo
            </th>
            <th className="w-1/4 border border-secondary-900 px-4 py-2">
              Acción
            </th>
          </tr>
        </thead>
        <tbody>
          {pdfData.map((pdf, index) => (
            <tr key={index} className="text-center">
              <td className="border border-secondary-900 px-4 py-2">
                {pdf.nombre}
              </td>
              <td className="flex items-center justify-center space-x-4 border border-secondary-900 px-4 py-2">
                <button
                  onClick={() =>
                    window.open(
                      `${API_URL}/uploads/presupuestos/cancelados/${pdf.nombre}`,
                      "_blank"
                    )
                  }
                >
                  <RiEyeLine size={20} />
                </button>
                <button onClick={() => moverArchivo(pdf.nombre, "aprobados")}>
                  ✅
                </button>
                <button onClick={() => moverArchivo(pdf.nombre, "cancelados")}>
                  📂
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default SubirPDF;
